export enum RemoteControlClickType {
	Click,
	DoubleClick,
	RightClick
}
